<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        Webshell 업로드
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">WSFinder</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Webshell 업로드</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------Regist-->
    <!-- detail_search -->
    <!-- detail_search -->
    <div class="card">
      <div class="card-body">
        <div class="d-flex flex-wrap align-items-center">
          <div class="title mr-auto">
            Webshell 업로드
          </div>
        </div>
        <hr v-if="dropzone && dropzone.bar_value > 0">
        <b-progress v-if="dropzone && dropzone.bar_value > 0" :max="100" show-value style="width:100%;" :value="dropzone.bar_value"></b-progress>
        <hr>
        <b-progress v-if="dropzone && dropzone.count > 0" :value="(dropzone.done / dropzone.count) * 100" show-value  :max="dropzone.count" :precision="2" style="width:100%;"></b-progress>
        <br>
        <div class="row mb-3">
          <div class="col-xl-12 col-md-12 d-flex align-self-center">
            <button type="button" class="btn btn-cancel btn-block" @click="clear">
              초기화
            </button>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-xl-12 col-md-12 d-flex align-self-center">
            URL : {{dropzoneOptions.url}}
          </div>
        </div>
        <div class="row">
          <div class="col-xl-12">
            <vue-dropzone
            @vdropzone-error="noti_error"
            @vdropzone-total-upload-progress="noti_progress"
            @vdropzone-success="noti_upload_item"
            @vdropzone-queue-complete="noti_upload_all"
            @vdropzone-file-added="noti_add"

            ref="dropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
          </div>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------Regist-->
    <!--//-------------------------------------------------------------------------검색조건-->
    <div class="d-flex flex-wrap align-items-center">
      <b-col v-if="view_detail !== false" sm="2">
        <span class="badge badge_border_primary mb-2">전체 : <span style="padding-left: 1rem">{{model.total.toString().padStart(6, nbsp) | number}}</span></span>
        <br>
        <span class="badge badge_border_info mb-2">완료 : <span style="padding-left: 1rem">{{model.approved.toString().padStart(6, nbsp) | number}}</span></span>
        <br>
        <span class="badge badge_border_warning mb-2">대기 : <span style="padding-left: 1rem">{{model.waiting.toString().padStart(6, nbsp) | number}}</span></span>
        <br>
        <span class="badge badge_border_danger mb-2">삭제 : <span style="padding-left: 1rem">{{model.deleted.toString().padStart(6, nbsp) | number}}</span></span>
      </b-col>
      
      <b-col :sm="view_detail !== false ? 10 : 12" class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel2" id="sel2" v-model="so.perPage" @change="refresh">
              <option disabled value="10">표시되는 개수 : 기본 10개</option>
              <option value=15>15</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="auto_refresh" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="">
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">삭제된 항목 숨기기</b-checkbox>
          </div>
          <div class="mb7 mr-2">
            <button type="button" class="btn btn-sm btn-addition" tabindex="4"  @click="regist_all">
              패턴 전체 적용(SSDEPP/HASH)
            </button>
          </div>
          <div class="mb7 mr-2">
            <button type="button" class="btn btn-sm btn-danger" tabindex="4" @click="delete_all">
             전체 삭제
            </button>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="관련된 정보가 없어요."
            :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" @row-clicked="detail" style="cursor:pointer;">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | datetime }}</template>
            <template slot="is_done" slot-scope="row">
              <b-badge variant="success" v-if="row.item.is_done && !row.item.is_del">완료</b-badge>
              <b-badge variant="danger" v-else-if="row.item.is_del">삭제</b-badge>
              <b-badge v-else variant="secondary">대기</b-badge>
            </template>
            <template slot="category" slot-scope="row">{{row.item.category ? (codes.code_category[row.item.category] || row.item.category) : '-'}}</template>
            <template slot="name" slot-scope="row">
              <span v-if="!row.item.is_del">{{ row.item.name }}</span>
              <span v-else>
                <del>{{ row.item.name }}</del>
              </span>
            </template>
            <template slot="source" slot-scope="row">
              <span v-if="!row.item.is_del">{{row.item.source}}</span>
              <span v-else>
                <del>{{row.item.source}}</del>
              </span>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
      <b-pagination class="pagination justify-content-center" size="sm" :total-rows="rowCount" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>